import { render, staticRenderFns } from "./ScipNumberSection.vue?vue&type=template&id=17336ef2&scoped=true&"
import script from "./ScipNumberSection.vue?vue&type=script&lang=js&"
export * from "./ScipNumberSection.vue?vue&type=script&lang=js&"
import style0 from "./ScipNumberSection.vue?vue&type=style&index=0&id=17336ef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17336ef2",
  null
  
)

export default component.exports